import React from 'react';
import SiteCharts from '../../../components/SiteCharts/SiteCharts';
import { saInterCuHandoutChartConfig } from '../chartConfigs';

interface InterCuHandoutSaEchartsProps {
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const InterCuHandoutSaEcharts: React.FC<InterCuHandoutSaEchartsProps> = ({ onFullscreenToggle, isFullscreen }) => (
  <SiteCharts config={saInterCuHandoutChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} />
);

export default InterCuHandoutSaEcharts;
